const $ = jQuery.noConflict();

'use strict';

const Helpers = {
	/**
	* @description Cache dom and strings
	* @type {object}
	*/

	/** @description Initialize */
	init: function() {
		this.activateChat();
		this.firstLetterString();

		const card = $('.profile-cards__item').parent();
		card.each(function() {
			const imgBox = $('.profile-cards__item-img');
			const item = $(this).find('.js-info-name');
			const text = item.html();
			const letterWrap = $(this).find('.js-letter span');
			letterWrap.text(text.charAt(0));

			imgBox.on('mouseenter', function() {
				$(this).find('.js-letter').addClass('hover-link');
			});
			imgBox.on('mouseleave', function() {
				$(this).find('.js-letter').removeClass('hover-link');
			});
		});
		const iconBlock = $('.icon-block');
		const itemBlock = $('.icon-block__item');
		const itemValue = itemBlock.val();
		if(iconBlock.length) {
			if (itemValue.length < 5) {
				itemBlock.each(function() {
					$(this).parent().addClass('icon-block__wrapper--small');
				});
			}
		}

		// more/less text
		$('.js-moreless').on('click', function() {
			$('.js-moretext').addClass('read-more');
			if ($('.js-moreless').text() === 'Read Less') {
				$(this).text('Read More');
				$('.js-moretext').removeClass('read-more');
			} else {
				$(this).text('Read Less');
				$('.js-moretext').addClass('read-more');
			}
		});
	},
	/** @description */
	activateChat() {
		function onTidioChatApiReady() {
			window.tidioChatApi.hide();
		}

		if (window.tidioChatApi) {
			window.tidioChatApi.on('ready', onTidioChatApiReady);
		}

		if (document.querySelector('.js-click-chat')) {
			document.querySelector('.js-click-chat').addEventListener('click', function() {
				window.tidioChatApi.show();
				window.tidioChatApi.open();
				$('#tidio-chat-iframe').addClass('is-active-chat');
			});
		}
	},

	firstLetterString() {
	}
};

export default Helpers;